module.exports = __webpack_public_path__ + "img/bluetooth.670e3a2d.svg";